import React from 'react';
import './PreSchool.css';

const levels = [
  {
    id: 'Balvatika-1',
    title: 'Balvatika-1',
    ageRange: '3 to 4 years',
    focusPoints: [
      'Introduction to pre-writing strokes, picture reading and early number concepts.',
      'Thematic activities that connect learning with everyday experiences.',
      'Hands-on art and craft that improves fine motor skills and creativity.'
    ]
  },
  {
    id: 'Balvatika-2',
    title: 'Balvatika-2',
    ageRange: '4 to 5 years',
    focusPoints: [
      'Systematic introduction to letters, sounds and number recognition.',
      'Structured circle time that builds confidence to speak in a group.',
      'Activities that encourage independence in eating, packing and organising belongings.'
    ]
  },
  {
    id: 'Balvatika-3',
    title: 'Balvatika-3',
    ageRange: '5 to 6 years',
    focusPoints: [
      'Reading readiness through phonics, word building and simple sentences.',
      'Mathematical readiness with number operations, patterns and problem solving.',
      'Value-based stories and activities that prepare children for Grade 1 routines.'
    ]
  }
];

const PreSchool = () => {
  return (
    <main className="preschool-page">
      <div className="preschool-container">
        <section className="preschool-hero">
          <h1 className="preschool-title">Balvatika at Pragati Vidyalaya</h1>
          <p className="preschool-tagline">
            A caring beginning that lays strong foundations for lifelong learning.
          </p>
          <p className="preschool-intro">
            Our Balvatika programme from Balvatika-1 to Balvatika-3 is designed to give every child a
            joyful start to school life. Classrooms are colourful, safe and child-friendly, with
            plenty of opportunities to explore, talk, move and create. Through planned play,
            stories, rhymes and hands-on activities, children develop language, number sense,
            motor skills and good habits at their own pace.
          </p>
        </section>

        <section className="preschool-approach">
          <h2 className="preschool-subtitle">Our Balvatika Approach</h2>
          <div className="approach-grid">
            <div className="approach-card">
              <h3>Play-based and joyful</h3>
              <p>
                Learning happens through games, songs, role play and exploration so that children
                enjoy coming to school every day.
              </p>
            </div>
            <div className="approach-card">
              <h3>Safe and nurturing</h3>
              <p>
                Teachers create a warm environment where children feel heard, cared for and
                respected, building trust and emotional security.
              </p>
            </div>
            <div className="approach-card">
              <h3>Readiness for Grade 1</h3>
              <p>
                By UKG, children are ready for formal schooling with age-appropriate reading,
                writing, number skills and classroom habits.
              </p>
            </div>
          </div>
        </section>

        <section className="levels-section">
          <h2 className="preschool-subtitle">Programmes from Balvatika 1 to 3</h2>
          <div className="levels-timeline">
            {levels.map((level) => (
              <div key={level.id} className="level-card">
                <div className="level-header">
                  <h3 className="level-title">{level.title}</h3>
                  <span className="level-age">{level.ageRange}</span>
                </div>
                <ul className="level-list">
                  {level.focusPoints.map((point, index) => (
                    <li key={index} className="level-list-item">
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>

        <section className="preschool-note">
          <h2 className="preschool-subtitle">Partnering with Parents</h2>
          <p className="preschool-intro">
            We believe that strong partnership between school and home is very important in the
            early years. Regular interaction with parents, simple home activities and honest
            feedback help every child feel supported. Together, we ensure that the first steps of
            schooling are happy, secure and meaningful.
          </p>
        </section>
      </div>
    </main>
  );
};

export default PreSchool;

